









import Vue from 'vue';

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    onChangeFunc: {
      type: Function,
      default: (): void => undefined,
    },
  },
  data() {
    return {
      isActive: this.$props.value,
    };
  },
  watch: {
    value(v) {
      this.$data.isActive = v;
    },
  },
  methods: {
    toggleActive() {
      this.$data.isActive = !this.$data.isActive;
      this.$emit('input', this.$data.isActive);
      this.$props.onChangeFunc();
    },
  },
});
